import { lazy } from "react";
import Loadable from "../../components/Loadable";

// SVV module has been removed - all routes cleared
const categoryRoute = [];

export default categoryRoute;
